import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';

interface ExpiredLicenseScreenProps {
  expirationDate?: Date | null;
}

export function ExpiredLicenseScreen({ expirationDate }: ExpiredLicenseScreenProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formattedDate = expirationDate
    ? new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(expirationDate instanceof Date ? expirationDate : new Date(expirationDate))
    : null;

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mb-6">
          <Clock className="w-8 h-8 text-amber-600 dark:text-amber-400" />
        </div>

        <h1 className="text-xl font-semibold text-neutral-900 dark:text-neutral-100">
          {t('App.Reader.ExpiredLicense.Title')}
        </h1>

        <p className="mt-3 text-neutral-600 dark:text-neutral-400">
          {formattedDate
            ? t('App.Reader.ExpiredLicense.MessageWithDate', { date: formattedDate })
            : t('App.Reader.ExpiredLicense.Message')}
        </p>

        <button
          onClick={() => navigate('/my-library')}
          className="mt-6 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors"
        >
          {t('App.Reader.ExpiredLicense.BackToLibrary')}
        </button>
      </div>
    </div>
  );
}
